const HTTP_CODE_STATUS = {
  /**40001未登录 40002token失效 40010账号被异地登录 40011token来源异常*/
  INVALID: [40001, 40002, 40010],
  NOAUTH: [40011],
  /**成功状态 */
  SUCCESS: 1,
  /**返回时间状态 */
  TIME_BACK_STATUS: 50023,
  /**alert弹窗 */
  ALERT: [2000001],
  /**上传成功 */
  JTS_UPLOAD_SUCCESS: 307,
  /**查詢成功 */
  JTS_SUCCESS: 20000,
  /**成功 */
  JTS_SUCCESS_CONFIRM: 60000
}
export default Object.freeze(HTTP_CODE_STATUS)
